import type { ChatThreadEvent } from '~/App/ChatThreads/@types'
import useChatThreadEntitiesSlice from '~/App/ChatThreads/slices/useChatThreadEntitiesSlice'

const useSetChatThreadEvent = (reload: () => void) => {
  const { getItem, patchItemData } = useChatThreadEntitiesSlice()

  return (data: ChatThreadEvent) => {
    const chatThreadState = getItem(data.attributes.chat_thread_id)
    if (!chatThreadState?.loaded) {
      reload()
      return
    }

    const events = chatThreadState?.data?.attributes?.events
    const index = events.data.findIndex(event => event.id === data.id)

    patchItemData(chatThreadState.data.id, {
      ...chatThreadState.data,
      attributes: {
        ...chatThreadState.data?.attributes,
        events: {
          ...chatThreadState.data?.attributes?.events,
          data:
            index === -1 ? events.data.concat(data) : Object.assign(events.data, { [index]: data }),
        },
      },
    })
  }
}

export default useSetChatThreadEvent
